let container = document.getElementById("landing-wrapper");
let menu = document.getElementById("menu");

function show() {
	container.classList.add("show");
	menu.classList.add("show");
}

export default show;
